import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';

/**
 * Admin product-activity snapshot. Callables only — no client Firestore reads.
 */
export async function getAdminActivitySummary() {
  const fn = httpsCallable(functions, 'getAdminActivitySummary');
  const { data } = await fn({});
  return data;
}
